// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M16.4123 18.5722V14.2894H17.8398V20H5V14.2894H6.42754V18.5722H16.4123Z" />
  <path d="M7.85666 17.1445H14.9944V15.717H7.85666V17.1445ZM14.2538 4L13.1084 4.85193L17.3682 10.5792L18.5137 9.72721L14.2538 4ZM10.7132 7.37651L16.1979 11.9443L17.1114 10.8474L11.6267 6.27955L10.7132 7.37651ZM8.92263 10.5508L15.3931 13.5643L15.9957 12.2702L9.52531 9.25676L8.92263 10.5508ZM7.99841 13.8954L14.9835 15.3635L15.2771 13.9665L8.29201 12.4984L7.99841 13.8954Z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-stackoverflow-D4G4nErK.js.map
